
















import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { ShippopCreateCodForm } from "../forms/ShippopCreateCodForm";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => ShippopCreateCodForm
    },
    validations: {
      type: Object
    }
  },
  computed: {
    ...proxyModel("email"),
    emailError() {
      return (this as any).validations.email.$error
        ? "email is required or invalid"
        : "";
    }
  }
});
